import React from 'react';
import PropTypes from 'prop-types';

import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import { Button } from 'fpay-ui'; // TODO: Replace for fpay ui components
import { getEnv } from '@config';
import { useCommon } from '@hooks';

const { publicPath } = getEnv();

const Container = styled.div`
  white-space: pre-line;
  display: flex;
  flex-direction: column;
  padding: 16px 20px 16px 20px;
  img {
    width: 100px;
    margin: 0 auto;
  }
  h4 {
    font-weight: normal;
    margin-top: 16px;
    margin-bottom: 0px;
    font-size: 20px;
    line-height: 24px;
    text-align: center;
    color: ${({ theme }) => theme.colors.gray800};
  }
  p {
    margin-top: 13px;
    font-size: 14px;
    line-height: 20px;
    text-align: center;
    color: ${({ theme }) => theme.colors.gray700};
  }
  > div {
    display: flex;
    justify-content: center;
    flex-direction: column;
    margin-top: 24px;
    ${({ theme }) => theme.breakpoint('md')} {
      flex-direction: row-reverse;
      button {
        :first-child {
          margin-left: 20px;
        }
      }
    }
    button {
      min-width: 120px;
      text-align: center;
    }
  }
`;

const ConfirmationModal = ({
  image,
  title,
  subTitle,
  confirmTitle,
  cancelTitle,
  htmlIdCancelButton = 'unidentified-id',
  htmlIdConfirmButton = 'unidentified-id',
  handleConfirm,
  handleCancel,
}) => {
  const { t } = useTranslation();
  const { resetModal } = useCommon();

  const _handleCancel = handleCancel ?? resetModal;

  const _handleConfirm = () => {
    handleConfirm();
    resetModal();
  };

  return (
    <Container>
      {image && <img alt={`${image}`} src={`${publicPath}/${image}`} />}
      {title && <h4 data-testid="confirmation-modal_title">{t(title)}</h4>}
      {subTitle && <p data-testid="confirmation-modal_subtitle">{t(subTitle)}</p>}
      <div>
        {handleConfirm && (
          <Button
            id={htmlIdConfirmButton}
            data-testId="modalConfirmButton"
            onClick={_handleConfirm}
          >
            {t(confirmTitle)}
          </Button>
        )}
        {
          <Button
            id={htmlIdCancelButton}
            data-testId="modalCancelButton"
            type="link"
            onClick={_handleCancel}
          >
            {t(cancelTitle)}
          </Button>
        }
      </div>
    </Container>
  );
};

ConfirmationModal.defaultProps = {
  image: null,
  title: null,
  subTitle: null,
  confirmTitle: 'common.buttonConfirm',
  cancelTitle: 'common.buttonCancel',
  handleConfirm: null,
  handleCancel: null,
};

ConfirmationModal.propTypes = {
  image: PropTypes.string,
  title: PropTypes.string,
  subTitle: PropTypes.string,
  confirmTitle: PropTypes.string,
  cancelTitle: PropTypes.string,
  handleConfirm: PropTypes.func,
  handleCancel: PropTypes.func,
};

export default ConfirmationModal;
